import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { camelizeKeys } from 'humps';
export var request = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var _ref2,
        _ref2$method,
        method,
        data,
        response,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref2$method = _ref2.method, method = _ref2$method === void 0 ? 'get' : _ref2$method, data = _ref2.data;
            _context.prev = 1;
            _context.next = 4;
            return axios({
              method: method,
              url: url,
              data: !data || Object.keys(data).length === 0 ? null : data
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", camelizeKeys(response.data));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error('request error: ', url);
            throw _context.t0;

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function request(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default request;